// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"d9d83f52","79":"8f549c7d","213":"5b79721a","344":"7b3e278a","453":"11dce4a7","454":"d71294a6","455":"37dd1e5f","573":"dcb97c3b"}[chunkId] + ".chunk.js";
};